import React from 'react';
import { useEnvironmentData } from '../EnvironmentProvider/EnvironmentProvider';

interface HideInProductionProps {
    children: React.ReactNode;
    extraParams?: boolean;
}

export const HideInProduction: React.FC<HideInProductionProps> = ({ children, extraParams = true }) => {
    const { hideInProduction } = useEnvironmentData();

    return hideInProduction && extraParams ? null : <>{children}</>;
};
